var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedXMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34636 12.0007L5.36631 8.21012C4.8779 7.74497 4.8779 6.9908 5.36631 6.52527L6.25085 5.68285C6.73926 5.2177 7.53114 5.2177 8.01994 5.68285L12 9.47338L15.9801 5.68285C16.4685 5.2177 17.2603 5.2177 17.7491 5.68285L18.6337 6.52527C19.1221 6.99042 19.1221 7.74459 18.6337 8.21012L14.6536 12.0007L18.6337 15.7912C19.1221 16.2563 19.1221 17.0105 18.6337 17.476L17.7491 18.3185C17.2607 18.7836 16.4685 18.7836 15.9801 18.3185L12 14.5279L8.01994 18.3185C7.53153 18.7836 6.73926 18.7836 6.25085 18.3185L5.36631 17.476C4.8779 17.0109 4.8779 16.2567 5.36631 15.7912L9.34636 12.0007Z",
    fill: "#DF5031"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedXMark);
export default __webpack_public_path__ + "static/media/RedXMark.efe724ba453d58637a52887b3960d079.svg";
export { ForwardRef as ReactComponent };